import { ComponentsOverrides } from '@mui/material';

const styleOverrides: ComponentsOverrides['MuiAccordion'] = {};

export const MuiAccordion = {
  styleOverrides,
};
